import { createCRUDService } from "./createCRUDService";

const BankService = createCRUDService("bank", {
  listBanks: "list-bank",
  createBank: "create-bank",
  updateBank: "update-bank",
  deleteBank: "delete-bank",
});

export default BankService;
